import { useDispatch, useSelector } from 'react-redux';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { formatDateLabel } from '../../../../lib/dayjs';
import { AppDispatch, RootState } from '../../../../store';
import JourneyWithNextSchedule from '../../JourneyWithNextSchedule';
import JourneyAction from '../../JourneyAction';
import CircleIcon from '../../CircleIcon';
import { JourneyActionPayload, getCurrentSchedule } from '..';
import { EScheduleSteps, initizalizeScheduleAppointment } from '../../../../features/schedule/schedule-slice';
import { initialState as journeyInitialState, saveCurrentJourney } from '../../../../features/journey';
import { EnumJourneyAction, getJourneyAction } from '../../../../utils/enum/journeyAction';
import Button from '@mui/material/Button';
import { Button as ButtonSmall } from '../style';
import {
  chooseCalendar,
  ChooseCalendarResult,
  EScheduleType,
  saveTypeOfAppointment,
  TypeOfAppointment
} from '../../../../features/calendar/calendar-slice';
import { IJourneyResp, ISchedules } from '../../../../services/journey.service';

export const AwaitingScheduleReturnSmall = ({ journey }: JourneyActionPayload) => {
  const {
    schedule: { confirm }
  } = useSelector((state: RootState) => state);
  const dispatch: AppDispatch = useDispatch();
  const currentSchedule = getCurrentSchedule(journey);
  const status = getJourneyAction(journey || journeyInitialState);

  const handleActionReturn = (journey: IJourneyResp) => {
    dispatch(chooseCalendar({ journey, schedule: currentSchedule, scheduleType: EScheduleType.RETURN })).then(res => {
      const payload = res.payload as ChooseCalendarResult;
      if (!payload) return;

      const isFlexible =
        payload.availableList.length > 1 &&
        payload.availableList.some(calendar => calendar.type === TypeOfAppointment.VIRTUAL_CONSULTATION) &&
        payload.availableList.some(calendar => calendar.type === TypeOfAppointment.PHYSICAL_APPOINTMENT);

      if (isFlexible) {
        dispatch(initizalizeScheduleAppointment({ currentStep: EScheduleSteps.returnAppointment }));
      } else {
        const typeOfAppointment = payload.availableList[0].type;
        dispatch(saveTypeOfAppointment({ typeOfAppointment: typeOfAppointment as TypeOfAppointment }));
        dispatch(initizalizeScheduleAppointment({ currentStep: EScheduleSteps.openCalendar }));
      }
    });
  };

  return (
    <>
      <JourneyWithNextSchedule
        journey={journey}
        schedule={currentSchedule as ISchedules}
        actionButton={
          confirm &&
          status !== EnumJourneyAction.AWAITING_SCHEDULE &&
          status !== EnumJourneyAction.AWAITING_SCHEDULE_RETURN ? (
            <> </>
          ) : (
            <ButtonSmall variant="contained" onClick={() => handleActionReturn(journey)}>
              Agendar retorno
            </ButtonSmall>
          )
        }
      />
    </>
  );
};

export const AwaitingScheduleReturnLarge = ({ journey }: JourneyActionPayload) => {
  const {
    schedule: { confirm }
  } = useSelector((state: RootState) => state);
  const dispatch: AppDispatch = useDispatch();
  const currentSchedule = getCurrentSchedule(journey);

  const handleActionReturn = () => {
    dispatch(saveCurrentJourney(journey));
    dispatch(chooseCalendar({ journey, schedule: currentSchedule, scheduleType: EScheduleType.RETURN })).then(res => {
      const payload = res.payload as ChooseCalendarResult;
      if (!payload) return;

      const isFlexible =
        payload.availableList.length > 1 &&
        payload.availableList.some(calendar => calendar.type === TypeOfAppointment.VIRTUAL_CONSULTATION) &&
        payload.availableList.some(calendar => calendar.type === TypeOfAppointment.PHYSICAL_APPOINTMENT);

      if (isFlexible) {
        dispatch(initizalizeScheduleAppointment({ currentStep: EScheduleSteps.returnAppointment }));
      } else {
        const typeOfAppointment = payload.availableList[0].type;
        dispatch(saveTypeOfAppointment({ typeOfAppointment: typeOfAppointment as TypeOfAppointment }));
        dispatch(initizalizeScheduleAppointment({ currentStep: EScheduleSteps.openCalendar }));
      }
    });
  };

  return (
    <>
      {!confirm ? (
        <>
          <JourneyAction
            icon={<CircleIcon border size="60px" icon={<WarningAmberIcon />} />}
            title="Agendar consulta de retorno"
            subtitle={`Agora você só precisa escolher o melhor horário para sua consulta de retorno`}
          >
            <Button variant="contained" color="primary" onClick={() => handleActionReturn()}>
              Agendar retorno
            </Button>
          </JourneyAction>
        </>
      ) : (
        []
      )}
    </>
  );
};
